<template>
  <div v-if="programmeResolved" id="programme-otj-page" class="content-with-spacing">
    <div class="heading-container header-margin">
      <h1>
        <i class="fas fa-clock" aria-hidden="true"></i> O.T.J. Logs - <b>{{ programmeStore.currentProgramme.name }}</b>
      </h1>
      <div v-if="apprenticeshipProgrammes.length > 1" class="programme-dropdown">
        <span>Select Programme:</span>
        <k-dropdown :options="apprenticeshipProgrammes" v-model="currentProgrammeId"></k-dropdown>
      </div>
    </div>
    <k-nav-tabs :tabs="tabs" :current-tab="currentTab"/>
    <router-view></router-view>
  </div>
</template>

<style scoped>
.heading-container h1 {
  padding: 15px 0;
}

.programme-dropdown {
  display: flex;
  align-items: center;
}

.programme-dropdown span {
  margin-right: 1em;
}
</style>

<script>
import KNavTabs from '@base-components/k-nav-tabs.vue';
import KDropdown from '@base-components/k-dropdown.vue';
import useAppProgrammeStore from '@stores/app-programme-store';

export default {
  components: {
    KNavTabs,
    KDropdown,
  },

  beforeMount() {
    this.checkProgrammeAccessibleAndSupportsOTJ(this.$route.params.programmeId);
  },

  data() {
    return {
      programmeResolved: false,
      programmeStore: useAppProgrammeStore(),
      // Convert to number because the route params is a string - this is relevant for the
      // dropdown where it expects the modelValue to be a number to match numeric IDs in the options
      currentProgrammeId: Number(this.$route.params.programmeId),
      tabs: [
        {
          name: 'Logs',
          routeName: 'programme_otj_logs',
          routeParams: {
            programmeId: this.$route.params.programmeId,
          },
        },
        {
          name: 'Guidance',
          routeName: 'programme_otj_guidance',
          routeParams: {
            programmeId: this.$route.params.programmeId,
          },
        },
      ],
    };
  },

  watch: {
    currentProgrammeId(newVal) {
      if (!newVal) return;
      this.checkProgrammeAccessibleAndSupportsOTJ(newVal);
    },
  },

  computed: {
    currentTab() {
      return this.$route.name;
    },
    apprenticeshipProgrammes() {
      return this.programmeStore.userProgrammes.filter(p => p.is_apprenticeship);
    },
  },

  methods: {
    checkProgrammeAccessibleAndSupportsOTJ(programmeId) {
      if (this.programmeStore.isProgrammeAccessible(programmeId)) {
        this.$logger.info('Programme accessible to this user - updating current programme in store', { programmeId });
        this.programmeStore.currentProgrammeId = Number(programmeId);
        // The getProgramme method in store accounts for IDs from routes being strings
        const selectedProgramme = this.programmeStore.getProgramme(programmeId);
        if (selectedProgramme?.is_apprenticeship) {
          this.$logger.info('Programme supports OTJ, routing to OTJ logs page', { programmeId });
          this.$router.push({
            name: 'programme_otj_logs',
            params: { programmeId },
            // Preserve any existing query params (e.g. ?tab=referred) so deep links keep the selected tab
            query: this.$route.query,
          });
          this.programmeResolved = true;
        } else {
          this.$logger.info('Programme does not support OTJ, routing to 404', { programmeId });
          this.$router.push({ name: '404' });
        }
      } else {
        this.$logger.info('Programme not accessible, routing to 404', { programmeId });
        this.$router.push({ name: '404' });
      }
    },
  },
};
</script>
